import { render, staticRenderFns } from "./CustomerCredit.vue?vue&type=template&id=2fcabfc2&scoped=true&"
import script from "./CustomerCredit.vue?vue&type=script&lang=js&"
export * from "./CustomerCredit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCredit.vue?vue&type=style&index=0&id=2fcabfc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcabfc2",
  null
  
)

export default component.exports